module.exports = __webpack_public_path__ + "img/about1.b3fcb8f3.png";